import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { AccueilComponent } from './accueil/accueil.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  CarteComponent,
  DialogOverviewExampleDialog
} from './carte/carte.component';
import { ConfirmTableComponent } from './confirm-table/confirm-table.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MomentPipe } from './pipes/moment-pipe';
import { ServeurComponent } from './serveur/serveur.component';
import { 
  CovidDialogOverviewExampleDialog,
  TopbarComponent 
} from './topbar/topbar.component';

import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';

let port = ':8080';
/*let url = `${window.location.protocol}//${window.location.hostname}${port}`;
const config: SocketIoConfig = { url: url, options: {} };*/

//const config: SocketIoConfig = { url: "http://localhost:8080", options: {} };
const config: SocketIoConfig = { url: "//lacartedigitale.fr:4512", options: {} };

@NgModule({
  declarations: [
    AppComponent,
    CarteComponent,
    NavbarComponent,
    ServeurComponent,
    TopbarComponent,
    AccueilComponent,
    ConfirmTableComponent,
    DialogOverviewExampleDialog,
    CovidDialogOverviewExampleDialog,
    MomentPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SocketIoModule.forRoot(config),
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatListModule,
    MatProgressSpinnerModule,
    NgxUsefulSwiperModule,
    NgxGoogleAnalyticsModule.forRoot('UA-168617620-2'),
    //NgxGoogleAnalyticsRouterModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
